<template>
	<div class="list-wrapper" :class="[aid === '616d43912cb570004dedec58' && 'qyqsdqz-wrapper']" v-if="activityData">
		<div class="banner">
			<img :src="activityData.image" alt="" />
		</div>
        <!-- 2021四川十大美食地标规则不一样 -->
        <div class="rule list-rule mstb-rule" v-if="activityData.desc && aid == '617218fdfbc5290049a5cf18'">
			<div class="rule-inner">
				<h4 class="rule-title">活动规则</h4>
				<div class="rule-content" v-html="activityData.desc"></div>
			</div>
		</div>
		<div class="list-top" v-if="topList.length">
			<h5 class="list-top-title title">{{ activityData.title }}排行榜</h5>
			<div class="list-top-list" :class="[topNameLong && 'islong']">
				<div class="list-top-head-wrap">
					<div class="list-top-head">
						<span>名次</span>
						<span>名称</span>
						<span>票数</span>
					</div>
					<div class="list-top-head" v-if="!topNameLong">
						<span>名次</span>
						<span>名称</span>
						<span>票数</span>
					</div>
				</div>
				<div class="list-top-inner">
					<ul class="list-top-body-wrap list-top-body-wrap-first">
						<li
							class="list-top-item"
							v-for="(item, index) in topList"
							:key="item.id"
							v-show="!topNameLong ? index % 2 == 0 : true"
							@click="goDetail(item.id)"
						>
							<span class="list-top-item-rank">{{ index + 1 }}</span>
							<span class="list-top-item-title">{{ item.info.title }}</span>
							<span class="list-top-item-count">{{ item.votes }}</span>
						</li>
					</ul>
					<ul class="list-top-body-wrap" v-if="!topNameLong">
						<li
							class="list-top-item"
							v-for="(item, index) in topList"
							:key="item.id"
							v-show="index % 2 != 0"
							@click="goDetail(item.id)"
						>
							<span class="list-top-item-rank">{{ index + 1 }}</span>
							<span class="list-top-item-title">{{ item.info.title }}</span>
							<span class="list-top-item-count">{{ item.votes }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="back-page">
			<span
				class="back-btn"
				v-if="activityData.homePath"
				@click="backHome(activityData.homePath)"
				>返回活动主页</span
			>
		</div>
		<div class="list-main">
			<div class="list-content">
				<h4 class="list-content-title title">
					{{ activityData.title }}{{aid !== '616d43912cb570004dedec58' ? '候选名单' : ''}}
				</h4>
				<button
					class="apply-btn"
					@click="goApply"
					v-if="activityData.voteIsApply"
				>
					报名
				</button>
				<div class="list-content-search">
					<form action="" onsubmit="return false;">
						<input
							class="list-content-search-input"
							@keydown="searchInput"
							v-model="searchVal"
							:placeholder="'请输入名称' + (activityData.field && activityData.field[0].no ? '或序号' : '')"
							type="search"
						/>
						<span
							class="list-content-search-btn"
							track="track"
							track-label="列表页--搜索按钮"
							@click="searchData"
							><img
								src="https://yunyingcdn.thecover.cn/o_1ctjt62rv191s1csg1veq1sutqpqr.png"
								alt=""
						/></span>
					</form>
				</div>
				<ul
					class="list-content-list"
					v-if="!isLoading && lastList && lastList.length"
				>
					<li
						class="list-content-item"
						v-for="(item, index) in lastList"
						:key="item.id"
					>
						<div class="list-content-img" @click="goDetail(item.id)">
							<img
								:src="
									item.info.image
										? item.info.image.indexOf('?') > -1
											? item.info.image + '&imageView2/1/w/400/h/300'
											: item.info.image + '?imageView2/1/w/400/h/300'
										: ''
								"
								alt=""
							/>
							<span v-if="item.info.no">{{ item.info.no }}</span>
						</div>
						<div class="list-content-detail">
							<p class="list-content-name">{{ item.info.title }}</p>
							<p class="list-content-subtitle" v-if="item.info.subtitle">{{item.info.subtitle}}</p>
							<p class="vote-num-box">{{ item.votes }}票</p>
							<p class="vote-btn" @click="handleVote(item.id, index)">投票</p>
						</div>
					</li>
				</ul>
				<p
					class="list-content-empty"
					v-if="isLoading || (lastList && !lastList.length)"
				>
					{{ isLoading ? "数据加载中，请稍候..." : "没有相关数据..." }}
				</p>
			</div>
			<div class="list-page">
				<span
					class="pre-btn"
					@click="prePage"
					:class="listOptions.page == 1 && 'disabled'"
					track="track"
					track-label="列表页--上一页"
					>上一页</span
				>
				<span
					class="next-btn"
					@click="nextPage"
					:class="listNum >= total && 'disabled'"
					track="track"
					track-label="列表页--下一页"
					>下一页</span
				>
			</div>
		</div>
        <!-- 2021四川十大美食地标规则不一样 -->
		<div class="rule list-rule" v-if="activityData.desc && aid != '617218fdfbc5290049a5cf18'">
			<div class="rule-inner">
				<h4 class="rule-title">活动规则</h4>
				<div class="rule-content" v-html="activityData.desc"></div>
			</div>
		</div>
		<dialog-component
			@loginEvent="getUserInfon"
			@wxauthorizeEvent="wxAuthorizeCallback"
			:baseData="baseData"
		></dialog-component>
	</div>
</template>

<script>
import COVER from "@/utils/COVER";
import DialogComponent from "@/components/Dialog";
import COVERAPP from "@/utils/COVERAPP";

import moment from "moment";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
	data() {
		return {
			aid: "",
			listNum: 0,
			lastList: null,
			topList: [],
			searchVal: "",
			topNameLong: false,
			listOptions: {
				aid: "",
				page: 1, // 当前页   默认值-1
				rows: 10, // 每一页数量   默认值-10
				keyword: "", //搜索关键词
				field: "", //需要搜索data数据对应的字段
				sort: "info.no",
			},
			total: 0,
			isLoading: false,
			openid: "",
			vatesTitle: "",
		};
	},
	props: ["activityData", "baseData"],
	computed: {
		...mapState(["page", "dialogData", "userInfo"]),
	},
	components: {
		DialogComponent,
	},
	created() {
		this.aid = this.$route.query.id || "";
		this.listOptions.page = this.page;
		this.listOptions.aid = this.aid;
		this.setPage(1);
    if (!this.activityData.isHideTop) {
      this.getTopList();
    }
		this.getVoteData();
	},
	mounted() {
		if (COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
			this.getUserInfon();
		}
		this.share();
		setTimeout(() => {
			this.setPageLoadingAsync(false);
		}, 500);
	},
	methods: {
		...mapMutations(["setUserInfo", "setPage", "setOpenDownLoadFlag"]),
		...mapActions([
			"setPageLoadingAsync",
			"setDialogDataAsync",
			"setUserInfoAsync",
		]),
		getUserInfon() {
			this.setUserInfoAsync();
		},
		// 返回活动主页
		backHome(homePath) {
			window.location.href = homePath;
		},
		//默认分享
		share() {
			let data = this.baseData.share;
			let shareData = {
				title: data.title,
				desc: data.desc,
				imgUrl: data.imgUrl,
				link: data.link || window.location.href,
			};
			COVER.share(shareData);
		},
		getShareData() {
			const _this = this;
			let shareData = this.baseData.share;
			return {
				title: "快来为TA打call，就差你了", // 分享标题
				desc:
					this.vatesTitle +
					"正在参与成渝文旅系列活动投票，我们来一起为TA打call吧！", // 分享描述
				link: window.location.href,
				imgUrl: shareData.imgUrl,
				type: "link",
				origin: "None",
				callback: function(res) {
					// 分享成功
					COVER.$post("/vote/share", {
						aid: _this.aid,
						uid: _this.userInfo.token,
						userinfo: _this.userInfo,
					}).then((ret) => {
						if (ret.errno == 0) {
							_this.setDialogDataAsync({
								message: "分享成功!",
								btns: [
									{
										text: "确认",
									},
								],
							});
							return;
						}
					});
				},
			};
		},
		// APP分享
		coverShare(vatesTitle) {
			const _this = this;
			COVER.share(_this.getShareData());
		},
		// APP主动调起分享
		doShare() {
			const _this = this;
			COVERAPP.Method.Share(_this.getShareData());
		},
		getVoteData() {
			if (this.isLoading) return;
			this.isLoading = true;
			COVER.$get("/vote", this.listOptions)
				.then((res) => {
					if (res.errno == 0) {
						let data = res.data;
						data.list &&
							(this.lastList = data.list || []) &&
							(this.listNum =
								(this.listOptions.page - 1) * this.listOptions.rows +
								data.list.length);
						this.total = data.total;
					}
					this.isLoading = false;
				})
				.catch(() => {
					this.isLoading = false;
				});
		},
		getTopList() {
			COVER.$get("/vote", {
				aid: this.aid,
				page: 1, // 当前页   默认值-1
				rows: this.activityData.topNumber || 100, // 每一页数量   默认值-10
				keyword: "", //搜索关键词
				field: "", //需要搜索data数据对应的字段
				sort: "votes",
			}).then((res) => {
				if (res.errno == 0) {
					let data = res.data;
					if (data.list.length) {
						this.topNameLong = data.list[0].info.title.length > 4;
						this.topList.push(...data.list);
					}
				}
			});
		},
		prePage() {
			this.listOptions.page > 1 &&
				this.listOptions.page-- &&
				this.getVoteData();
			this.$track(this.aid, "click", {
				value: "点击上一页",
			});
		},
		nextPage() {
			this.listNum < this.total &&
				this.listOptions.page++ &&
				this.getVoteData();
			this.$track(this.aid, "click", {
				value: "点击下一页",
			});
		},
		searchData() {
			this.$track(this.aid, "click", {
				button: "search",
				value: this.searchVal.trim(),
			});
			this.listOptions.keyword = this.searchVal.trim();
			this.listOptions.field = !!Number(this.listOptions.keyword)
				? "no"
				: "title";
			this.listOptions.page = 1;
			this.listNum = 0;
			this.getVoteData();
		},
		searchInput(e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				this.searchData();
			}
		},
		handleVote(id, index) {
            if (this.activityData.isAppHandle && !COVERAPP.Attribute.isApp()) {
                this.setOpenDownLoadFlag(true);
                return;
            }
			this.voteOptions = {
				aid: this.aid,
				uid: this.userInfo.token,
				vid: id,
				userinfo: this.userInfo,
				openid: this.openid,
			};
			this.$track(this.aid, "click", {
				button: "vote",
				value: id,
			});
			this.$nextTick(() => {
				this.vote(id, index);
			});
		},
		vote(id, index) {
			const _this = this;
			this.vatesTitle = this.lastList[index].info.title;
			if (!COVERAPP.Attribute.isApp() && this.activityData.external) {
				if (
					localStorage.getItem(
						this.aid + "_skip_app_" + moment().format("YYYYMMDD")
					)
				) {
					this.setDialogDataAsync({
						message:
							"投票次数已用完！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
						btns: [
							{
								text: "确认",
								className: "downLoad-app",
							},
						],
					});
					return;
				}
				this.setDialogDataAsync({
					message:
						"恭喜你，投票成功！到APP内投票，还可以额外获得每天50次的机会，赶紧使用吧！",
					btns: [
						{
							text: "确认",
							className: "downLoad-app",
						},
					],
				});
				this.lastList[index].votes++;
				localStorage.setItem(
					this.aid + "_skip_app_" + moment().format("YYYYMMDD"),
					true
				);
				return;
			}
			if (!this.userInfo.token) {
				this.setDialogDataAsync({
					message: "参与活动，需登录!",
					btns: [
						{
							text: "去登录",
							className: "login-btn",
						},
						{
							text: "取消",
							className: "close-btn",
						},
					],
				});
				return;
			}
			this.setDialogDataAsync({
				message: "投票中，请稍候...",
			});
			this.activityData.external && this.coverShare();
			COVER.$post("/vote", this.voteOptions).then((res) => {
				if (res.errno == 0) {
					const shareNoticeKey =
						this.voteOptions.aid +
						"_share_notice_" +
						moment().format("YYYYMMDD");
					if (
						this.activityData.shareCount &&
						!localStorage.getItem(shareNoticeKey)
					) {
						// 今天第一次投票
						this.setDialogDataAsync({
							message:
								"感谢你为我投票！分享后还能额外获得" +
								this.activityData.shareCount +
								"次投票机会，记得分享哦！",
							btns: [
								{
									text: "确认",
									className: "share-btn",
									callback: () => {
										_this.doShare();
									},
								},
							],
						});
						// 记录今天已投票
						localStorage.setItem(shareNoticeKey, true);
					} else {
						// 今天不是第一次投票
						this.setDialogDataAsync({
							message: "投票成功",
							btns: [
								{
									text: "确认",
								},
							],
						});
					}
					this.lastList[index].votes++;
				} else if (COVERAPP.Attribute.isApp() && res.errno == 1250) {
					this.setDialogDataAsync({
						message: "参与活动，需绑定微信!",
						btns: [
							{
								text: "绑定微信",
								className: "wxAuthorize-btn",
							},
							{
								text: "取消",
								className: "close-btn",
							},
						],
					});
				} else if (res.errno == 2022) {
					this.setOpenDownLoadFlag(true);
				} else {
					this.setDialogDataAsync({
						message: res.errmsg || "投票失败，请重试",
						btns: [
							{
								text: "确认",
							},
						],
					});
				}
			}).catch(() => {
                this.setDialogDataAsync(null);
            });
		},
		wxAuthorizeCallback(openid) {
			let _this = this;
			let verifyOpenid = `${_this.userInfo.user_id.toString(
				36
			)}_${openid}_${(+moment().format("YYYYMMDD")).toString(36)}`;
			_this.userInfo.openid = openid;
			_this.openid = verifyOpenid;
			store.commit("setUserInfo", _this.userInfo);
		},
		goApply() {
			this.$router.push(`/apply?id=${this.aid}`);
		},
		goDetail(id) {
			this.setPage(this.listOptions.page);
			this.$router.push(`/detail?id=${this.aid}&vid=${id}`);
		},
	},
};
</script>

<style lang="less">
input[type="search"]::-webkit-search-cancel-button {
	-webkit-appearance: none;
}
.list {
	background-color: #f7f7f9;
}
.title {
	font-weight: bold;
	font-size: 0.574074rem;
	color: #383838;
	letter-spacing: 0.1rem;
	line-height: 1.3;
	text-align: center;
	padding-bottom: 0.185185rem;
	position: relative;
	margin: 0 0 0.814815rem;
}
.title::after {
	content: "";
	position: absolute;
	left: 50%;
	margin-left: -0.296296rem;
	bottom: 0;
	width: 0.592593rem;
	height: 0.111111rem;
	background-color: #db332a;
}
.list-top {
	position: relative;
	margin: -0.648148rem 0.185185rem 0rem;
	background-color: #fff;
	border-radius: 0.15rem;
	box-shadow: 0 0 0.277778rem #eeeef2;
	padding: 0.722222rem 0 0.62963rem;
	overflow: hidden;
}
.list-top-title {
	font-size: 0.4rem;
	letter-spacing: 0;
	margin-bottom: 0.333333rem;
	padding-bottom: 0.2rem;
}
.list-top-list {
	overflow: hidden;
}
.list-top-inner {
	overflow: hidden;
	overflow-y: auto;
	max-height: 2.933333rem;
}
.list-top-head-wrap {
	font-size: 0.296296rem;
	color: #909090;
	letter-spacing: 0.02rem;
	font-weight: bold;
	overflow: hidden;
}
.list-top-head,
.list-top-body-wrap {
	width: 50%;
	float: left;
	overflow: hidden;
	box-sizing: border-box;
	padding: 0 0.277778rem 0.103704rem;
}
.list-top-head {
	display: flex;
}
.list-top-head:first-child,
.list-top-body-wrap-first {
	border-right: 1px solid #db332a;
}
.list-top-head span,
.list-top-item span {
	width: 0.796296rem;
	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	padding: 0.05rem 0;
	flex-shrink: 0;
	line-height: 1.4;
}
.list-top-head span:nth-of-type(2),
.list-top-item .list-top-item-title {
	padding: 0.05rem 0.37037rem;
	text-overflow: ellipsis;
	flex: 1;
}
.list-top-head span:nth-of-type(3),
.list-top-item .list-top-item-count {
	width: 1.388889rem;
}
.list-top-item .list-top-item-count {
	text-align: right;
}
.list-top-body-wrap {
	overflow: hidden;
	padding-bottom: 0;
}
.list-top-item {
	padding-bottom: 0.048148rem;
	width: 100%;
	overflow: hidden;
	display: flex;
	align-items: center;
	height: 0.586667rem;
	box-sizing: border-box;
}
.list-top-item:last-child {
	padding-bottom: 0;
}
.list-top-item-rank {
	font-size: 0.388889rem;
	color: #db332a;
	font-weight: bold;
}
.list-top-item-title {
	font-size: 0.305556rem;
	color: #383838;
}
.list-top-item-count {
	color: #fc424d;
	font-size: 0.333333rem;
	text-align: right;
}
.islong {
	.list-top-head,
	.list-top-body-wrap {
		width: 100%;
		border-right: none;
	}
	.list-top-inner {
		max-height: 5.866667rem;
	}
}
.back-page {
	letter-spacing: -4px;
	text-align: center;
	margin: 0.5rem 0;
	.back-btn {
		font-size: 0.444444rem;
		color: #db332a;
		box-sizing: border-box;
		border: 2px solid #db332a;
		height: 1.018519rem;
		border-radius: 0.8rem;
		font-weight: bold;
		letter-spacing: 0.03rem;
		padding: 0.22rem 0;
		text-align: center;
		display: inline-block;
		width: 3.648148rem;
		margin: 0 0.462963rem;
	}
}
.list-main {
	background-color: #fff;
	border-radius: 0.15rem;
	box-shadow: 0 0 0.277778rem #eeeef2;
	padding: 1.018519rem 0 1.12963rem;
	margin: 0 0.185185rem 0.925926rem;
}
.list-content-title {
	font-size: 0.48rem;
	letter-spacing: 0;
	padding-bottom: 0.22rem;
	margin-bottom: 0.740741rem;
}
.apply-btn {
	appearance: none;
	border: none;
	outline: none;
	padding: 0 0.8rem;
	line-height: 1.092593rem;
	color: #fff;
	background: #dc372f;
	font-size: 0.444444rem;
	margin: 0 auto 0.5rem;
	border-radius: 0.2rem;
	display: block;
	cursor: pointer;
}
.list-content-search {
	padding: 0 0.37037rem;
	position: relative;
}
.list-content-search-input {
	outline: none;
	-webkit-appearance: none;
	appearance: none;
	border: 1px solid #db332a;
	border-radius: 0.15rem;
	display: block;
	width: 100%;
	line-height: 1.3;
	font-size: 0.388889rem;
	color: #db332a;
	height: 1.018519rem;
	box-sizing: border-box;
	padding: 0.277778rem;
	background-color: #f4f3f9;
	font-weight: bold;
}
.list-content-search-btn {
	position: absolute;
	padding: 0 0.296296rem;
	width: 0.518519rem;
	height: 1.018519rem;
	line-height: 1.018519rem;
	top: 0;
	right: 0.37037rem;
}
.list-content-search-btn img {
	vertical-align: middle;
}
.list-content-list {
	padding: 0.787037rem 0 0.509259rem;
	font-size: 0;
	letter-spacing: -4px;
	text-align: center;
}
.list-content-empty {
	font-size: 0.4rem;
	text-align: center;
	padding: 0.8rem 0;
}
.list-content-item {
	width: 3.962963rem;
	letter-spacing: 0;
	display: inline-block;
	vertical-align: top;
	margin-bottom: 0.62963rem;
}
.list-content-item:nth-of-type(2n) {
	margin-left: 1.037037rem;
}
.list-content-img {
	border: 2px solid #db332a;
	background-color: #f26565;
	border-radius: 0.2rem;
	overflow: hidden;
	box-sizing: border-box;
	height: 3rem;
	position: relative;
	span {
		position: absolute;
		color: #fff;
		font-size: 0.35rem;
		left: 0;
		top: 0;
		background-color: #ffc340;
		line-height: 1.3;
		height: 0.5rem;
		width: 0.9rem;
		text-align: center;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-left-radius: 0.2rem;
		border-bottom-right-radius: 0.2rem;
	}
}
.list-content-img a {
	display: block;
}
.list-content-detail {
	padding-top: 0.185185rem;
	text-align: center;
}
.list-content-name {
	color: #383838;
	font-size: 0.444444rem;
	font-weight: bold;
	line-height: 1.4;
	margin: 0 0 0.1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.list-content-subtitle {
	font-size: 0.3rem;
	line-height: 1.4;
	margin: 0 0 0.1rem;
	word-break: break-all;
	color: #333;
}
.list-content-post {
	color: #383838;
	font-size: 0.333333rem;
	line-height: 1.3;
	margin: 0 0 0.1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.vote-num-box {
	font-size: 0.444444rem;
	color: #fc424d;
	margin: 0 0 0.148148rem;
	font-weight: 600;
}
.vote-btn {
	font-size: 0.444444rem;
	color: #fff;
	font-weight: bold;
	width: 3.148148rem;
	height: 1.092593rem;
	border: 2px solid #f5df78;
	padding: 0.2rem 0;
	line-height: 1.3;
	text-align: center;
	background: #dc372f;
	border-radius: 0.8rem;
	margin: 0 auto;
	box-shadow: 0 0.185185rem 0.462963rem #fac3c3;
	letter-spacing: 0.1rem;
	box-sizing: border-box;
}
.vote-btn.voted {
	color: #db332a;
	border: 2px solid #db332a;
	background: #fff;
}
.list-page {
	padding: 0 0.37037rem;
	overflow: hidden;
}
.list-page span {
	font-size: 0.444444rem;
	color: #db332a;
	font-weight: bold;
	line-height: 1.3;
	height: 1.018519rem;
	text-align: center;
	width: 50%;
	box-sizing: border-box;
	display: block;
	border: 2px solid #db332a;
	float: left;
	padding: 0.2rem 0;
	letter-spacing: 0.1rem;
}
.list-page span.disabled {
	color: #bababc;
}
.list-page .pre-btn {
	border-top-left-radius: 0.8rem;
	border-bottom-left-radius: 0.8rem;
	border-right-width: 1px;
}
.list-page .next-btn {
	border-top-right-radius: 0.8rem;
	border-bottom-right-radius: 0.8rem;
	border-left-width: 1px;
}
.rule {
	padding-bottom: 1rem;
}
.rule-title {
	font-size: 0.444444rem;
	color: #ee2e2e;
	line-height: 1.3;
	text-align: center;
	letter-spacing: 0.03rem;
	background-color: #fff;
	border-radius: 0.8rem;
	width: 2.777778rem;
	height: 0.740741rem;
	margin: 0 auto 0.601852rem;
	padding: 0.12963rem 0;
	box-sizing: border-box;
}
.rule-content {
	font-size: 0.333333rem;
	line-height: 1.5;
	padding: 0 0.37037rem 0 0.833333rem;
	letter-spacing: 0.02rem;
}
// 2021年度青羊区十大群众暖心实事排行榜样式
.qyqsdqz-wrapper .list-top-head span:nth-of-type(2), .qyqsdqz-wrapper .list-top-item .list-top-item-title{
    text-align: left;
}
//2021四川十大美食地标规则样式
.mstb-rule {
    position: relative;
	margin: -0.648148rem 0.185185rem 1rem;
	background-color: #fff;
	border-radius: 0.15rem;
	box-shadow: 0 0 0.277778rem #eeeef2;
	padding: 0.4rem 0 0.62963rem;
	overflow: hidden;
}
</style>
